export default __webpack_public_path__ + "37a4d114ba9c42c9d6a3e821a6c20383.png";